import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["source"];

  copy(event) {
    event.preventDefault();

    if (this.sourceTarget.value !== undefined) {
      navigator.clipboard.writeText(this.sourceTarget.value);
    } else {
      navigator.clipboard.writeText(this.sourceTarget.innerHTML);
    }

    const instance = tippy(event.target);
    instance.show();
    setTimeout(() => {
      instance.hide();
    }, 2000);
  }
}
